import { PushToDataLayer } from "@asosteam/asos-web-event-tracking-bridge";
import {
  emitConsentChangedEvent,
  setupConsentChangedListener,
} from "@/components/consent";

export const handleOneTrustLoad = (pushToDataLayer: PushToDataLayer) => {
  setupConsentChangedListener(() => emitConsentChangedEvent(pushToDataLayer));
  emitConsentChangedEvent(pushToDataLayer);
};
